import styled from 'styled-components';

export const ZonePopulationContainer = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: 40% 60%;
  grid-gap: 15px;
  row-gap: 15px;
`;

export const NationalityContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: #fafbfc;
  border-radius: 20px;
  grid-row: 1;
  grid-column: 1/-1;
`;
export const SmallGraphInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 10px;
`;

export const SmallGraphValue = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #212632;
`;
export const SmallGraphSuffix = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #747d93;
`;

export const CustomLegendContainer = styled.div`
  width: 45%;
  padding: 14px;
`;

export const SubsectionTitle = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #212632;
`;

export const NationalitiesContainer = styled.div`
  width: 100%;
  height: 90%;
  display: grid;
  align-items: center;
  grid-template-columns: 20% 20% 20% 20% 20%;
  grid-template-rows: auto 2% auto;
`;

export const NationalityValue = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
  font-weight: 500;
`;

export const NationalityTag = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #747d93;
`;

export const NationalValue = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  grid-column: 1;
  grid-row: 1;
  color: #03045e;
`;
export const EuropeValue = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  grid-row: 3;
  color: #48b5e4;
`;
export const AsiaValue = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  grid-row: 3;
  color: #e1897f;
`;
export const AfricaValue = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  grid-row: 3;
  color: #ddaf11;
`;

export const OceaniaValue = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  grid-row: 3;
  color: #24a49b;
`;

export const AmericaValue = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  grid-row: 3;
  color: #c278ff;
`;
export const LegendSeparator = styled.div`
  width: 100%;
  height: 3px;
  background-color: #eff2f7;
  grid-column: 1/-1;
  grid-row: 2;
`;

// mean age

export const SmallGraphContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: #fafbfc;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

export const StudyLevelContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 30px;
  background-color: #fafbfc;
  border-radius: 20px;
`;

// graph

export const BarGraph = styled.div`
  width: 100%;
  height: 70%;
  display: flex;
  flex-direction: row;
  column-gap: 15px;
  align-items: center;
  justify-content: flex-end;
  position: relative;
`;

type HorizontalBarProps = {
  width: string;
  backgroundcolor: string;
};

export const HorizontalBar = styled.div<HorizontalBarProps>`
  height: 10px;
  background-color: ${(props) => props.backgroundcolor};
  width: ${(props) => props.width || '0%'};
  border-radius: 0 30px 30px 0;
`;

export const BarValue = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #747d93;
`;

export const BarGroup = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  width: 100%;
  height: 90%;
  box-sizing: border-box;
`;

export const XAxis = styled.div`
  position: relative;
  width: 85%;
  height: 10%;
  bottom: 10px;
  display: flex;
  justify-content: space-between;
  justify-self: flex-start;
  align-self: flex-end;
  font-size: 10px;
  color: #212632;
  z-index: 1;
  border-top: 2px solid #ccc;
`;

export const XAxisLabel = styled.span`
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 15px;
  color: #747d93;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 12px;
`;

export const YAxis = styled.div`
  position: absolute;
  width: 100%;
  height: 80%;
  top: 0;
  left: 0;
  bottom: 20px;
  font-size: 10px;
  color: #212632;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-self: flex-end;
  justify-content: space-evenly;
`;

export const YAxisLabel = styled.span`
  width: 100%;
  display: grid;
  line-height: 1;
  grid-template-columns: 15% 85%;
  color: #212632;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 12px;
`;

export const XAxisStudyLevel = styled.div`
  position: relative;
  width: 70%;
  height: 10%;
  bottom: 10px;
  display: flex;
  justify-content: space-between;
  justify-self: flex-start;
  align-self: flex-end;
  font-size: 10px;
  color: #212632;
  z-index: 1;
  border-top: 2px solid #ccc;
`;

export const YAxisLabelStudyLevel = styled.span`
  width: 100%;
  display: grid;
  line-height: 1;
  grid-template-columns: 30% 70%;
  color: #212632;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 12px;
`;
